import { useState } from "react";
import { useTranslation } from "@/shared/providers/LanguageProvider";

type LightPaymentCardProps = {
  card: PaymentCard;
};

export function LightPaymentCard({ card }: LightPaymentCardProps) {
  const [enabled, setEnabled] = useState(card.enabled ?? false);
  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden rounded-2xl bg-card-muted p-6">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-medium text-muted">{t.common.cardNumber}</p>
          <p className="mt-1 text-lg font-semibold tracking-widest text-foreground">{card.cardNumber}</p>
        </div>
        <label className="relative inline-flex cursor-pointer items-center">
          <input type="checkbox" checked={enabled} onChange={(e) => setEnabled(e.target.checked)} className="peer sr-only" />
          <div className="h-6 w-11 rounded-full bg-border after:absolute after:left-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:bg-card after:shadow-sm after:transition-all peer-checked:bg-primary peer-checked:after:translate-x-full" />
        </label>
      </div>

      <div className="mt-8">
        <p className="text-xs text-muted">{t.common.balance}</p>
        <p className="text-xl font-bold text-foreground">{card.balance}</p>
      </div>

      <div className="absolute bottom-6 right-6">
        <div className="flex gap-1">
          <div className="h-6 w-6 rounded-full bg-pink opacity-80" />
          <div className="-ml-3 h-6 w-6 rounded-full bg-yellow opacity-80" />
        </div>
      </div>
    </div>
  );
}
